<template>
  <div class="step"
       v-on="step_block===true?null:status===1?{ click: () => changeStatus(2) }:''"
       :class="step_block===true?'status-unavailable':status===1?'status-empty':status===2?'status-active':status===3?'status-success':''">
    <div class="step__preview" v-if="status===1">
      <div></div>
      <div class="step__preview-title">
        <div class="step__name">Link your Fortnite</div>
        <div class="step__subname">So we can get you into a party with one tap!</div>

      </div>
      <div class="step__preview-icon">
        <svg width="60" height="60" viewBox="0 0 60 60" fill="none" xmlns="http://www.w3.org/2000/svg">
          <circle cx="30" cy="30" r="30" fill="#E7E7E7"/>
          <path d="M30 12V47" stroke="black"/>
          <path d="M47 29.5L12 29.5" stroke="black"/>
        </svg>
      </div>
    </div>
    <div class="step__form" v-if="status===2">
      <div class="step__form-title">Link your Fortnite account</div>
      <div class="step__form-subtitle">One of the eBlitz Ninjas (our in-game bot) will send you a friend request! You'll
        need your game or EPIC Game Launcher open for this.
      </div>


      <div class="step__form-with-button" :class="step!==1?'step__form-with-button_disabled':''">
        <div class="step__form-with-button-left" :class="step!==1?'step__form-with-button_disabled':''">
          <div class="step__form-label">Please input your EPIC display name</div>
          <v-text-field
              v-model.trim="name"
              :disabled="step!==1"
          ></v-text-field>
          <div v-if="step==1&&$v.name.$dirty&&!$v.name.required" class="step__form-input-error">
            Name field is required
          </div>

        </div>
        <div class="step__form-button-wrap step__form-with-button_adaptive"
             :class="step!==1?'step__form-with-button_adaptive-hide':''">
          <div class="step__form-error" v-if="errors">{{ errors }}</div>
        </div>
        <div class="step__form-with-button-right" v-if="resend_code_after===0&&resend_code_status===0">
          <button class="step__form-button" :class="loading&&step===1?'step__form-button-loading':''"
                  @click="sendName()"
                  :disabled="loading||step!==1">Invite Me
            <div class="lds-ring" v-if="step===1&&loading">
              <div></div>
              <div></div>
              <div></div>
              <div></div>
            </div>
          </button>
        </div>

        <div class="step__form-with-button-right" v-else-if="resend_code_after===0&&resend_code_status===1">
          <button class="step__form-button" :class="loading&&step===1?'step__form-button-loading':''"
                  @click="sendName(true)"
          >Resend
            <div class="lds-ring" v-if="resend_loading">
              <div></div>
              <div></div>
              <div></div>
              <div></div>
            </div>
          </button>
          <p class="step__form-button_display-name change_name" :class="loading&&step===1?'step__form-button-loading':''"
             @click="changeName"
          >Change Display Name
          </p>
        </div>
        <div class="step__form-with-button-right" v-else>
          <button class="step__form-button step__form-button-loading"
                  disabled>Resend {{ resend_code_after }}
          </button>
          <p class="step__form-button_display-name change_name" :class="loading&&step===1?'step__form-button-loading':''"
             @click="changeName"
          >Change Display Name
          </p>
        </div>
        <div class="step__form-skip-button-wrap step__form-with-button_adaptive"
             :class="step!==1?'step__form-with-button_adaptive-hide':''">
          <a class="step__form-skip-button" v-if="!(step_2_status==3&&step_4_status==3)" @click="skip">Skip if you want
            completed later</a>
        </div>
      </div>


      <div class="step__form-with-button" :class="step!==2?'step__form-with-button_disabled':''">
        <div class="step__form-with-button-left">
          <div class="step__form-with-button-left-tooltip-wrap">
            <div class="step__form-label">Please enter the number in the bot's name, (the one that just sent you a
              friend
              request in game)
            </div>
            <div @click="showModal" class="step__form-with-button-left-tooltip"
                 :class="step!==2?'step__form-with-button-left-tooltip_hidden':''">
              HELP!
            </div>
          </div>
          <v-text-field
              v-model.trim="number"
              :disabled="step!==2"
          ></v-text-field>
          <div v-if="step==2&&$v.number.$dirty&&!$v.number.required" class="step__form-input-error">
            Number field is required
          </div>

        </div>
        <div class="step__form-button-wrap step__form-with-button_adaptive"
             :class="step!==2?'step__form-with-button_adaptive-hide':''">
          <div class="step__form-error" v-if="errors">{{ errors }}</div>
        </div>

        <div class="step__form-with-button-right">
          <button class="step__form-button"
                  :class="{'step__form-button-loading': loading&&step===2,'step__form-button_disable' : loading||step!==2}"
                  @click="sendNumber" :disabled="loading||step!==2">Send
            <div class="lds-ring" v-if="step===2&&loading">
              <div></div>
              <div></div>
              <div></div>
              <div></div>
            </div>
          </button>

        </div>
        <div class="step__form-skip-button-wrap step__form-with-button_adaptive"
             :class="step!==2?'step__form-with-button_adaptive-hide':''">
          <a class="step__form-skip-button" v-if="!(step_2_status==3&&step_4_status==3)" @click="skip">Skip if you want
            completed later</a>
        </div>
      </div>


      <div class="step__form-button-wrap step__form-skip-button_main">
        <div class="step__form-error" v-if="errors">{{ errors }}</div>
      </div>
      <div class="step__form-skip-button-wrap step__form-skip-button_main">
        <a class="step__form-skip-button" v-if="!(step_2_status==3&&step_4_status==3)" @click="skip">Skip if you want
          completed later</a>
      </div>
    </div>


    <div class="step__preview" v-if="status===3">
      <div></div>
      <div class="step__preview-title">
        <div class="step__name">Fortnite Account Linked</div>
      </div>

      <div class="step__preview-icon">
        <svg width="60" height="60" viewBox="0 0 60 60" fill="none" xmlns="http://www.w3.org/2000/svg">
          <circle cx="30" cy="30" r="30" fill="#FFD500"/>
          <path d="M17 30L26.5 39.5L43.5 21" stroke="black"/>
        </svg>
      </div>
    </div>
    <modal name="my-first-modal" :clickToClose="false" :classes="'step__form-tooltip-modal'" :width="450" :height="600">
      <div class="step__form-tooltip-modal-close" @click="closeModal">
        <svg width="77" height="77" viewBox="0 0 77 77" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path
              d="M38.5 76C59.2107 76 76 59.2107 76 38.5C76 17.7893 59.2107 1 38.5 1C17.7893 1 1 17.7893 1 38.5C1 59.2107 17.7893 76 38.5 76Z"
              stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
          <path d="M49 28L28 49" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
          <path d="M28 28L49 49" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>
      </div>
      <img class="step__form-tooltip-modal-img" src="../../assets/MATCH.gif">
      <!--      <div class="step__form-tooltip-modal-info">-->
      <!--        <div class="step__form-tooltip-modal-title">Finding the code</div>-->
      <!--        <div class="step__form-tooltip-modal-title">in the eBlitz bot's name</div>-->
      <!--        <div class="step__form-tooltip-modal-subtitle">Fortnite client</div>-->
      <!--      </div>-->

    </modal>
  </div>
</template>

<script>

import {required} from 'vuelidate/lib/validators'

export default {
  name: "step3",
  data: () => ({
    step: 1,

    name: '',
    number: '',

    resend_code_after: 0,
    resend_code_status: 0,

    errors: '',
    loading: false,
    resend_loading: false
  }),
  validations: {
    name: {required},
    number: {required},
  },
  computed: {
    url() {
      return this.$store.getters.url
    },
    status() {
      return this.$store.getters.step_3_status
    },
    step_2_status() {
      return this.$store.getters.step_2_status
    },
    step_4_status() {
      return this.$store.getters.step_4_status
    },

    step_block() {
      return this.$store.getters.step_block
    }
  },
  mounted() {
    this.checkInputs()
    window.addEventListener('keyup', this.sendName_enter);
    window.addEventListener('keyup', this.sendNumber_enter);
  },
  methods: {
    checkInputs() {
      if (localStorage.getItem('resend_timer_data')) {
        let resend_timer_data = JSON.parse(localStorage.getItem('resend_timer_data'))
        this.name = resend_timer_data.name
        this.resend_code_after = resend_timer_data.time
        this.startTimer(resend_timer_data.time)
        this.resend_code_status = 1
        this.step = 2
      } else {
        return
      }
      if (localStorage.getItem('eblitz_number')) {
        this.number = localStorage.getItem('eblitz_number')
      } else {
        return
      }
    },
    sendName_enter(e) {
      if (e.keyCode === 13 && this.status === 2 && this.step === 1) {
        this.sendName();
      }
    },
    async sendName(resend = false) {
      //Validation
      if (!this.$v.name.required) {
        this.$v.$touch()
        this.errors = ''
        return
      }
      this.$v.$reset()
      if (resend)
        this.resend_loading = true
      else
        this.loading = true
      this.errors = ''

      let params = {
        method: 'epic',
        displayname: this.name,
        platform: 'web',
        registration_id: '',
        is_resend: resend
      }
      await axios.post('/' + this.url.service_name_auth + '/' + this.url.version_number + '/' + 'auth-link', params).then(res => {
        this.startTimer();
        if (resend)
          this.resend_loading = false;
        else
          this.loading = false;
        this.step = 2
      }).catch(err => {
        this.errors = err.response.data.message
        if (resend)
          this.resend_loading = false;
        else
          this.loading = false;
        // this.errors = ''
      });

    },
    sendNumber_enter(e) {
      if (e.keyCode === 13 && this.status === 2 && this.step === 2) {
        this.sendNumber();
      }
    },
    async sendNumber() {
      if (!this.$v.number.required) {
        this.$v.$touch()
        this.errors = ''
        return
      }
      this.$v.$reset()
      this.loading = true
      let params = {
        method: "epic",
        displayname: this.name,
        code: this.number,
        platform: 'web',
        registration_id: '',
      }


      await axios.post('/' + this.url.service_name_auth + '/' + this.url.version_number + '/' + 'auth-link', params).then(res => {
        localStorage.setItem('eblitz_number', this.number)
        this.loading = false
        if (this.step_4_status !== 3) {
          let stepData = {
            step: 4,
            status: 2,
            complete: true,
          }
          this.$store.commit('updateStepStatus', stepData)
        } else if (this.step_2_status !== 3) {
          let stepData = {
            step: 2,
            status: 2,
            complete: true,
          }
          this.$store.commit('updateStepStatus', stepData)
        } else {
          let stepData = {
            step: 3,
            status: 3,
          }
          this.$store.commit('updateStepStatus', stepData)
        }
      }).catch(err => {
        this.errors = err.response.data.message
        this.loading = false
      });
    },
    startTimer(time = 60) {
      this.resend_code_after = time;
      this.resend_code_status = 1
      this.timer = setInterval(() => {
        if (this.resend_code_after !== 0) {
          this.resend_code_after--
          let resend_data = {
            time: this.resend_code_after,
            name: this.name
          }
          localStorage.setItem('resend_timer_data', JSON.stringify(resend_data));
        } else {
          this.stopTimer();
        }
      }, 1000)
    },
    stopTimer() {
      clearInterval(this.timer)
    },
    showModal() {
      this.$modal.show('my-first-modal');

    },
    closeModal() {
      this.$modal.hide('my-first-modal');
    },
    skip() {
      if (this.step_4_status !== 3) {
        let stepData = {
          step: 4,
          status: 2
        }
        this.$store.commit('updateStepStatus', stepData)
      } else if (this.step_2_status !== 3) {
        let stepData = {
          step: 2,
          status: 2
        }
        this.$store.commit('updateStepStatus', stepData)
      }
    },
    changeStatus(status) {
      let stepData = {
        step: 3,
        status: status
      }
      this.$store.commit('updateStepStatus', stepData)
    },
    changeName() {
      this.resend_code_after = 0
      this.resend_code_status = 0
      this.step = 1
    }
  }
}
</script>

<style>
.vm--modal {
  overflow: visible !important;
}

.vm--overlay {
  background: rgba(0, 0, 0, 0.5) !important;
}

.step__form-tooltip-modal {
  background-color: #000 !important;

  box-shadow: none;
}
.change_name{
  text-align: center!important;
}
.step__form-tooltip-modal-close {
  position: absolute;
  z-index: 10;
  bottom: calc(100% + 0.5rem);
  left: 50%;
  transform: translate(-50%, 0);

  height: 77px;
  width: 77px;

  border-radius: 50%;

  cursor: pointer;

  overflow: hidden;

  transition: background-color .2s linear;
}

.step__form-tooltip-modal-close:hover {
  background-color: rgba(255, 255, 255, 0.5);
}

.step__form-tooltip-modal-img {
  position: absolute;
  z-index: 5;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}

.step__form-tooltip-modal-info {
  text-align: center;

  width: 80%;

  position: absolute;
  z-index: 10;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);

}

.step__form-tooltip-modal-title {
  font-size: 1.35rem;
  color: #FFD600;


}

.step__form-tooltip-modal-subtitle {
  font-size: 1.2rem;
  color: #a7a7a7;

  margin-top: 0.5rem;
}

.step__form-button_display-name {
  font-size: 15px;
  margin-top: 5px;
  text-decoration: underline;
  text-align: right;
  cursor: pointer;
}

@media (max-height: 800px) {
  .step__form-tooltip-modal-close {
    top: 0.5rem;
    bottom: auto;
  }
}

@media (max-width: 470px) {
  .vm--container > div {
    left: 0 !important;

    width: 100vw !important;
  }
}

</style>
